import { ReactElement } from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';
import { DeleteGuardian } from './delete-guardian';

export type DeleteGuardianDialogProps = {
	userId: string;
	guardianPhone: string;
	isOpen?: boolean;
	onSuccess?: () => void;
	onClose?: () => void;
};
export function DeleteGuardianDialog(
	props: DeleteGuardianDialogProps
): ReactElement {
	const { userId, guardianPhone, isOpen, onSuccess, onClose } = props;

	return (
		<Dialog isOpen={isOpen}>
			<div className={Classes.DIALOG_BODY}>
				<DeleteGuardian
					userId={userId}
					guardianPhone={guardianPhone}
					onSuccess={onSuccess}
				/>
			</div>
			<div className={Classes.DIALOG_FOOTER}>
				<div className={Classes.DIALOG_FOOTER_ACTIONS}>
					<Button onClick={onClose}>Close</Button>
				</div>
			</div>
		</Dialog>
	);
}
